import { statusOptions } from "@/features/license-fee/list/utils/license-fee-mappings";

export const getLicenseFeeStatus = (status?: string) => {
  if (!status) return "-";
  return statusOptions.find((option) => option.slug === status)?.name || "-";
};

export const getLicenseFeeStatusById = (id?: number | string) => {
  if (!id) return "-";
  return statusOptions.find((option) => option.id === Number(id))?.slug || id;
};

export const getLicenseFeeStatusList = () => {
  return statusOptions.map((option) => ({
    id: option.id,
    name: option.name,
  }));
};
